module.exports = __webpack_public_path__ + "img/card-provider-active.6df5597c.svg";